import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import cookie from "js-cookie";
import server from "../../api/server";
import { updateMeta } from "../../store/actions/metaAction";

const CompanyProfile = () => {
	const [loading, setLoading] = useState(true);
	const [sectionData, setSectionData] = useState({});
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(
			updateMeta({
				title: "بروفايل الشركة",
				breadcrumb: "بروفايل الشركة",
			})
		);
		fetchSectionData();
	}, []);

	const fetchSectionData = async () => {
		try {
			const response = await server(cookie).get("/pages/companyProfile");
			const section = response?.data?.data?.page?.sections?.[0] || {};
			setSectionData(section);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقًا!");
		} finally {
			setLoading(false);
		}
	};

	const handlePDFUpload = async e => {
		const file = e.target.files[0];
		if (!file || file.type !== "application/pdf") {
			toast.error("يرجى اختيار ملف PDF فقط.");
			return;
		}

		setLoading(true);

		const formData = new FormData();
		formData.append("file", file);

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/upload`,
				formData,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}
			);

			const pdfPath = response.data.data.file.path;

			// Update the section with the new PDF url
			await server(cookie).put(
				"/pages/companyProfile/sections/companyProfile",
				{
					section: {
						url: pdfPath,
					},
				}
			);

			toast.success("تم رفع الملف وتحديث البيانات بنجاح!");
			setSectionData(prev => ({ ...prev, url: pdfPath }));
		} catch (error) {
			toast.error("فشل في رفع الملف أو تحديث البيانات!");
		} finally {
			setLoading(false);
		}
	};

	return (
		<section>
			{loading && <Loader />}

			<div className="card-body">
				<h5>رفع ملف PDF</h5>
				<input
					type="file"
					accept="application/pdf"
					onChange={handlePDFUpload}
				/>
				{sectionData?.url && (
					<div className="mt-3">
						<p>الملف الحالي:</p>
						<a
							href={`${process.env.REACT_APP_MAIN_URL}/${sectionData.url}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							عرض الملف الحالي
						</a>
					</div>
				)}
			</div>
		</section>
	);
};

export default CompanyProfile;
